import type { LegalDoc } from '../../types/legal'
import { privacyPolicy } from './privacy'
import { feeSchedule } from './fees'
import { complaintsPolicy } from './complaints'

export const legalDocs: Record<string, LegalDoc> = {
  privacy: privacyPolicy,
  fees: feeSchedule,
  complaints: complaintsPolicy,
}
